//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config/index'
import { getProductList, getActivity } from '@/api/youzheng.js'
import { getshoplist } from '@/api/hgfw'
import { getList } from '@/api/pintuan'
import CountDown from '@/components/vue2-countdown'
export default {
  name: 'yougonghui',
  data () {
    return {
      goodsList: [],
      shoplist: [],
      pintuanlist: [],
      tuangoulist: [],
      baseUrl: config.baseUrl,
      activity: 0,
      currentTime: ''
    }
  },
  components: {
    CountDown
  },
  created () {
    this.getlist()
    this.shop()
    this.getpintanlist()
    this.gettuangou()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    let timestamp = (new Date()).getTime()
    this.currentTime = timestamp
  },
  methods: {
    linkhgsc () {
      this.$router.push({ name: 'test' })
    },
    // 获取商品列表
    getlist () {
      getProductList({
        prodname: this.searchVal,
        usercredit: 0,
        ordertype: 0,
        grouptype: 0,
        producttype: this.selected,
        isnew: 0,
        page: 1,
        rows: 3,
        orderdesc: ''
      }).then(res => {
        if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
          this.goodsList = res.returnValue.list
        }
      })
    },
    // 跳转到详情页
    gomore (id) {
      this.$router.push({ name: 'mallProductDetail', params: { id: id } })
    },
    shop () {
      getshoplist({
        page: 1,
        rows: 3
      }).then(res => {
        this.shoplist = res.returnValue.rows
      })
    },
    getpintanlist () {
      getList({
        page: 1,
        rows: 2
      }).then(res => {
        this.pintuanlist = res.returnValue.list
      })
    },
    shopClick (item) {
      window.open(item.link)
    },
    pintuanClick (item) {
      this.$router.push({
        name: 'pintuanDetail',
        params: {
          id: item.id
        }
      })
    },
    gettuangou () {
      getActivity({
        page: 1,
        rows: 3,
        accountid: this.accountid
      }).then(res => {
        if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
          res.returnValue.rows.forEach((item, index) => {
            this.$set(this.tuangoulist, this.tuangoulist.length, item)
          })
        }
        this.tuangoulist.forEach(item => {
          item.signstartdate = new Date(item.signstartdate.replace(/-/g, '/')).getTime()
          item.signenddate = new Date(item.signenddate.replace(/-/g, '/')).getTime()
        })
      })
    },
    goDetail (id) {
      this.$router.push({ name: 'tuanGouDetail', params: { id: id } })
    }
  }
}
